import { useDispatch, useSelector, type TypedUseSelectorHook } from "react-redux";
import type { AppDispatch, RootState } from "./store";

/**
 * Pre-typed react-redux hooks. Import these, never `useSelector`/`useDispatch`
 * from "react-redux" directly.
 *
 * `useAppSelector` binds the store shape once, so selectors get `state` typed as
 * `RootState` for free - no `(state: RootState) => ...` annotation to write, and
 * no way to write an untyped one. `useAppDispatch` carries the thunk-aware
 * dispatch signature, so `dispatch(someThunk(...))` type-checks and returns a
 * promise you can `.unwrap()` instead of collapsing to `any`.
 *
 * See docs/plans/partial/frontend-type-strictness-ratchet.md, phase 3.
 */
export const useAppDispatch = () => useDispatch<AppDispatch>();

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
